/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatrixCareAdmissionCopyFlags
 */
export interface MatrixCareAdmissionCopyFlags {
    /**
     * Always true. The drawer renders this checked and disabled.
     */
    demographic_info: boolean;
    /**
     * 
     */
    allergies: boolean;
    /**
     * 
     */
    dnr: boolean;
    /**
     * 
     */
    medical_history: boolean;
    /**
     * 
     */
    active_diagnoses: boolean;
    /**
     * 
     */
    active_care_plan: boolean;
    /**
     * 
     */
    care_location: boolean;
    /**
     * 
     */
    agency_assignments: boolean;
    /**
     * 
     */
    physician_contacts: boolean;
    /**
     * 
     */
    organization_contacts: boolean;
    /**
     * 
     */
    personal_contacts: boolean;
    /**
     * 
     */
    insurance: boolean;
}

/**
 * Check if a given object implements the MatrixCareAdmissionCopyFlags interface.
 */
export function instanceOfMatrixCareAdmissionCopyFlags(value: object): value is MatrixCareAdmissionCopyFlags {
    if (!('demographic_info' in value) || value['demographic_info'] === undefined) return false;
    if (!('allergies' in value) || value['allergies'] === undefined) return false;
    if (!('dnr' in value) || value['dnr'] === undefined) return false;
    if (!('medical_history' in value) || value['medical_history'] === undefined) return false;
    if (!('active_diagnoses' in value) || value['active_diagnoses'] === undefined) return false;
    if (!('active_care_plan' in value) || value['active_care_plan'] === undefined) return false;
    if (!('care_location' in value) || value['care_location'] === undefined) return false;
    if (!('agency_assignments' in value) || value['agency_assignments'] === undefined) return false;
    if (!('physician_contacts' in value) || value['physician_contacts'] === undefined) return false;
    if (!('organization_contacts' in value) || value['organization_contacts'] === undefined) return false;
    if (!('personal_contacts' in value) || value['personal_contacts'] === undefined) return false;
    if (!('insurance' in value) || value['insurance'] === undefined) return false;
    return true;
}

export function MatrixCareAdmissionCopyFlagsFromJSON(json: any): MatrixCareAdmissionCopyFlags {
    return MatrixCareAdmissionCopyFlagsFromJSONTyped(json, false);
}

export function MatrixCareAdmissionCopyFlagsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareAdmissionCopyFlags {
    if (json == null) {
        return json;
    }
    return {
        
        'demographic_info': json['demographic_info'],
        'allergies': json['allergies'],
        'dnr': json['dnr'],
        'medical_history': json['medical_history'],
        'active_diagnoses': json['active_diagnoses'],
        'active_care_plan': json['active_care_plan'],
        'care_location': json['care_location'],
        'agency_assignments': json['agency_assignments'],
        'physician_contacts': json['physician_contacts'],
        'organization_contacts': json['organization_contacts'],
        'personal_contacts': json['personal_contacts'],
        'insurance': json['insurance'],
    };
}

export function MatrixCareAdmissionCopyFlagsToJSON(json: any): MatrixCareAdmissionCopyFlags {
    return MatrixCareAdmissionCopyFlagsToJSONTyped(json, false);
}

export function MatrixCareAdmissionCopyFlagsToJSONTyped(value?: MatrixCareAdmissionCopyFlags | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'demographic_info': value['demographic_info'],
        'allergies': value['allergies'],
        'dnr': value['dnr'],
        'medical_history': value['medical_history'],
        'active_diagnoses': value['active_diagnoses'],
        'active_care_plan': value['active_care_plan'],
        'care_location': value['care_location'],
        'agency_assignments': value['agency_assignments'],
        'physician_contacts': value['physician_contacts'],
        'organization_contacts': value['organization_contacts'],
        'personal_contacts': value['personal_contacts'],
        'insurance': value['insurance'],
    };
}

